/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import notificationService from '@/services/notification.service';
import router from '@/router';
import modules from './modules';

const BACK = 'BACK';
const LOADING = 'LOADING';
const CLASSROOM = 'CLASSROOM';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  state: {
    backEnabled: true,
    pageLoading: false,
    classroomId: null,
  },
  getters: {
    backEnabled: state => state.backEnabled,
    pageLoading: state => state.pageLoading,
    classroomId: state => state.classroomId,
  },
  actions: {
    setClassroom({ commit }, value) {
      commit(CLASSROOM, value, {
        root: true,
      });
    },
    setBackAction({ commit }, value) {
      commit(BACK, value, {
        root: true,
      });
    },
    routerPush({ commit }, { name, query, params }) {
      router.push({
        name,
        query,
        params,
      });
    },
    isPageLoading({ commit, dispatch }, value) {
      dispatch(
        'notificationService',
        {
          type: value ? 'showLoader' : 'stopLoader',
          text: 'loading',
        },
        { root: true },
      );
      commit(LOADING, value, {
        root: true,
      });
    },
    notificationService({ commit }, { type, text }) {
      notificationService[type](text);
    },
  },
  mutations: {
    [BACK](state, data) {
      state.backEnabled = data;
    },
    [LOADING](state, data) {
      state.pageLoading = data;
    },
    [CLASSROOM](state, data) {
      state.classroomId = data;
      localStorage.setItem('classroom_id', data);
    },
  },
});

// Automatically run the `init` action for every module,
// if one exists.
for (const moduleName of Object.keys(modules)) {
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`);
  }
}

export default store;
